import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface SchedulerContextType {
  isOpen: boolean;
  defaultSlug: string | null;
  openScheduler: (slug?: string) => void;
  closeScheduler: () => void;
}

const SchedulerContext = createContext<SchedulerContextType | undefined>(undefined);

export function SchedulerProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultSlug, setDefaultSlug] = useState<string | null>(null);

  const openScheduler = useCallback((slug?: string) => {
    setDefaultSlug(slug || null);
    setIsOpen(true);
  }, []);

  const closeScheduler = useCallback(() => {
    setIsOpen(false);
    setDefaultSlug(null);
  }, []);

  return (
    <SchedulerContext.Provider value={{ isOpen, defaultSlug, openScheduler, closeScheduler }}>
      {children}
    </SchedulerContext.Provider>
  );
}

export function useScheduler() {
  const ctx = useContext(SchedulerContext);
  if (!ctx) throw new Error('useScheduler must be used within SchedulerProvider');
  return ctx;
}
